export default function ContactModal() {
  return (
    <div className="flex flex-col md:flex-row py-1 px-2 text-xs text-white font-normal gap-2 transition-all duration-200">
      <a href="https://github.com/Arceen" target="_blank" rel="noreferrer">
        <div className="transition duration-150 hover:shadow-[0_0_10px_2px_rgba(255,255,255,0.65)]  flex items-center justify-center w-8 h-8 cursor-pointer opacity-40 hover:opacity-100 grayscale hover:grayscale-0 border-2 border-transparent  hover:border-white/80 rounded-full p-[2px] ">
          <img src="/socials/github.svg" height="16px" width="16px" alt="git" />
        </div>
      </a>

      <a
        href="https://facebook.com/madman365/"
        target="_blank"
        rel="noreferrer"
      >
        <div className="pointer-events-auto transition duration-150 hover:shadow-[0_0_10px_2px_rgba(59,130,246,0.65)]  flex items-center justify-center w-8 h-8 cursor-pointer opacity-40 hover:opacity-100 grayscale hover:grayscale-0 border-2 border-transparent  hover:border-blue-500 rounded-full p-[2px]">
          <img src="/socials/fb2.svg" height="6px" width="10px" alt="fb" />
        </div>
      </a>
      <a
        href="https://www.linkedin.com/in/a-h-m-annur-6b45a21bb/"
        target="_blank"
        rel="noreferrer"
      >
        <div className="transition duration-150 hover:shadow-[0_0_10px_2px_rgba(62,159,234,0.65)]  cursor-pointer opacity-40 hover:opacity-100 grayscale w-8 h-8 flex items-center justify-center hover:grayscale-0 border-2 border-transparent  hover:border-[#3e9fea] rounded-full p-[2px] ">
          <img
            src="/socials/li.svg"
            height="10px"
            width="14px"
            alt="linkedin"
          />
        </div>
      </a>

      <a href="mailto:niloyman01@gmail.com" target="_blank" rel="noreferrer">
        <div className="transition duration-150 hover:shadow-[0_0_10px_2px_rgba(196,50,50,0.65)]  cursor-pointer opacity-40 hover:opacity-100 grayscale w-8 h-8 flex items-center justify-center hover:grayscale-0 border-2 border-transparent hover:border-[#c43232] rounded-full p-[2px] ">
          <img
            src="/socials/google.svg"
            height="16px"
            width="16px"
            alt="Mail"
          />
        </div>
      </a>

      <a href="https://wa.me/8801938723055" target="_blank" rel="noreferrer">
        <div className="transition duration-150 hover:shadow-[0_0_10px_2px_rgba(34,197,94,0.65)] cursor-pointer opacity-40 hover:opacity-100 grayscale hover:grayscale-0 border-2 w-8 h-8 flex items-center justify-center border-transparent hover:bg-gray-200/20 hover:border-green-500 rounded-full p-[4px] ">
          <img
            src="/socials/whatsapp.png"
            height="16px"
            width="16px"
            alt="wassap"
          />
        </div>
      </a>
    </div>
  );
}
